import { NotificationLevel } from '@/graphql/types';

export const NotificationBorderVariants = {
    [NotificationLevel.Success]: 'border-l-notification-success',
    [NotificationLevel.Info]: 'border-l-notification-info',
    [NotificationLevel.Warning]: 'border-l-notification-warning',
    [NotificationLevel.Error]: 'border-l-notification-error',
} as const satisfies Record<NotificationLevel, string>;
